import React, {useEffect} from "react";
import "./Leaderboard.scss";
import LeaderboardBox from "../../components/LeaderboardComp/LeaderboardBox";
import LeaderboardTable from "../../components/LeaderboardComp/LeaderboardTable";
import oneImg from "../../assets/icons/01.svg";
import twoImg from "../../assets/icons/02.svg";
import threeImg from "../../assets/icons/03.svg";
import useFetch, {baseUrl} from "../../hooks/useFetch";
import LoaderOverlap from "../../components/ReusableComponent/LoaderOverlap/LoaderOverlap";

function Leaderboard() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const {isLoading, serverError, apiData} = useFetch(`${baseUrl}web/leaderboard/`);
  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isLoading]);

  // if (isLoading) {
  //   return <div></div>;
  // }

  if (serverError) {
    return <div>Error loading leaderboard data</div>;
  }

  const leaderboardImages = [oneImg, twoImg, threeImg];

  return (
    <div className="lb_wrapper">
      {isLoading && <LoaderOverlap />}
      <div className="lb_intro">
        <span className="intro_head">LEADERBOARD</span>
        <h1>
          Our Top Performing <span className="gradientText">Analyst</span>
        </h1>
        <p>
          Check out the current leaderboard showcasing the most profitable and active Analyst in real-time. These top traders are setting the standard with their outstanding performance and strategic
          trading.
        </p>
      </div>
      <div className="lb_date">
        <p>08/10/2024</p>
      </div>

      <div className="lb_content">
        <div className="lb_box_wrapper">
          {apiData?.leaderboard?.map((item, index) => (
            <LeaderboardBox
              key={item.id || index}
              image={leaderboardImages[index]}
              name={item.name}
              as={item.account_size}
              profit={item.total_returns}
              gain={item.return_percentage}
              equity={item.lastest_equity}
            />
          ))}
        </div>
        <LeaderboardTable />
      </div>
      <p className="note">*Only registered users can see the full leaderboard in the client area. Sign up now to join the leaderboard.</p>
    </div>
  );
}

export default Leaderboard;
